import React from "react";
import styles from "./Avatar.module.css";

export const Avatar = (props: { img: string }) => {
    return <img src={props.img} alt="avatar" className={styles.fill} />;
};
